import { Feature, Point } from "geojson";
import { Map, Marker, Popup } from "maplibre-gl";
import { environment } from "src/environments/environment";
import { LayerParams } from "../../map/layer-manager";
import { MapLayer } from "../map-layer";

/**
 * Camada dos pontos das câmeras da defesa civil.
 */
export class CameraLayer extends MapLayer {

  markers: Marker[] = [];

  colorMapping: {[key: string]: string} = {
    'SEM CHUVA': '#bdeb07',
    'CHUVA LEVE': '#bdeb07',
    'CHUVA FORTE': '#bdeb07',
    'ALAGAMENTO': '#ff0841'
  }

  hasData(layerParams: LayerParams): boolean {
    let { points } = layerParams;
    return points != null && points.features.length > 0;
  }

  remove(map: Map): void {

    if (this.markers == null) {
      return;
    }

    this.markers.forEach(marker => {
      marker.remove();
    });

    // this.markers = [];
  }

  show(map: Map, layerParams: LayerParams): void {
    // throw new Error("Method not implemented.");

    let { points } = layerParams;

    if (points == null || points.features.length == 0) {
      return;
    }

    this.markers = [];

    points.features.forEach((feature, index) => {

      let { nome, tempo, classe, nome_arquivo: nomeArquivo, 
        imagem_existe: imagemExiste, } = feature.properties;

      let hasClass = classe != null ? true : false;
      let color = hasClass ? this.colorMapping[classe] : '#52524f';

      let customMarker = this.createCustomMarker(index, color);
      let popupDiv = this.createPopupContent(feature);

      let marker = this.createMapMarker(map, customMarker, popupDiv, feature, color);

      this.markers.push(marker);
    });
  }

  /**
   * Cria o elemento raiz do marker da câmera.
   * 
   * @param map mapa onde o marker será adicionado.
   * @param customMarker elemento do desenho do pin da câmera.
   * @param popupDiv elemento do popup exibido ao clicar no pin.
   * @param feature feature da câmera com a classificação da imagem.
   * @param color cor a ser usada no pin.
   * @returns marker da câmera.
   */
  public createMapMarker(
    map: Map, 
    customMarker: HTMLDivElement, 
    popupDiv: HTMLDivElement,
    feature: Feature<Point>, 
    color: string) {

    return new Marker({element: customMarker, color})
      .setLngLat([feature.geometry.coordinates[0], feature.geometry.coordinates[1]])
      .setPopup(
        new Popup({ offset: 25, maxWidth: 'fit-content' }) // add popups
          .setDOMContent(popupDiv)
      )
      .addTo(map);
  }

  /**
   * Cria o elemento do pin com o desenho da câmera.
   * 
   * @param index índice da câmera para identificar o marker exclusivamente.
   * @param color cor usada no pin, correspondente à classificação da imagem.
   * @returns elemento html do pin da câmera.
   */
  private createCustomMarker(index: number, color: string) {

    let customMarker = document.createElement('div');
    
    customMarker.innerHTML = `<svg version="1.1" id="Camada_Camera_${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
    <style type="text/css">
    .stc0-${index}{fill:none;}
    .stc1-${index}{fill:${color};stroke:#7A7A7A;stroke-width:5.000000e-02;stroke-miterlimit:10;}
    .stc2-${index}{fill:#FFFFFF;stroke:#7A7A7A;stroke-width:5.000000e-02;stroke-miterlimit:10;}
    </style>
    <path class="stc0-${index}" d="M0,0h24v24H0V0z"/>
    <path class="stc1-${index}" d="M12,2c-4.4,0-8,3.6-8,8c0,0.1,0,0.1,0,0.2c0,3.3,2.7,7.3,8,11.8c5.3-4.6,8-8.5,8-11.8c0.1-4.4-3.4-8.1-7.8-8.2
      C12.1,2,12.1,2,12,2z"/>
    <path
      d="M 8.6504052,13.666131 V 7.7622663 H 14.554268 V 10.299084 L 16.030234,8.8231173 V 12.60528 l -1.475966,-1.475965 v 2.536816 z"
      id="stc2-${index}"
      style="fill:#ffffff;stroke-width:0.184496" />
    </svg>`;

    customMarker.className = 'marker';

    return customMarker;
  }

  /**
   * Cria o conteúdo do popup a ser exibido ao clicar no pin.
   * 
   * @param feature dados da câmera com classificação e nome do arquivo.
   * @returns elemento html do popup.
   */
  private createPopupContent(feature: Feature) {

    let { nome, tempo, classe, nome_arquivo: nomeArquivo, 
      imagem_existe: imagemExiste, } = feature.properties;

    let hasClass = classe != null ? true : false;

    // 1. Criar elementos para o popup
    let popupDiv: HTMLDivElement = document.createElement('div');

    // 2. Insere conteúdo html nos elementos
    let imgSrc = `${environment.imagesBaseUrl}/${nomeArquivo}`;
    let imgTag = imagemExiste == false ? '' : `<a target="_blank" href="${imgSrc}">
        <img src="${imgSrc}" style="max-width: 400px">
      </a>`;

    popupDiv.innerHTML = `<h3 style="text-align: center;font-weight: bold;">${nome}</h3>`;
    
    // Caso exista uma classificação para a câmera naquele momento, exibi-la
    if (hasClass) {
      popupDiv.innerHTML = popupDiv.innerHTML.concat(
        `<p>Tempo: ${tempo}</p>
        <p>Classe: ${classe}</p>
        ${imgTag}`
      );
    }
    else {
      popupDiv.innerHTML = popupDiv.innerHTML.concat(
        `<p>Classe: SEM INFORMAÇÃO</p>`
      );
    }

    return popupDiv;
  }
}
